import React from 'react';

export const Input = ({ children, ...props }) => {
    return <div>{React.cloneElement(children, { ...props })}</div>;
};



// WEBPACK FOOTER //
// ./src/UI/Components/Inputs/InputContainer/index.js